import { Component, Inject, OnInit } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { VariedadService } from '../../variedad/service/variedad.service';
import { Observable } from 'rxjs-compat';

@Component({
  selector: 'app-dialog-details',
  templateUrl: './dialog-details.component.html',
  styleUrls: ['./dialog-details.component.css']
})
export class DialogDetailsComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DialogDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private variedadService: VariedadService) { }
  varietyDetailObs!: Observable<any>;

  ngOnInit(): void {
    if (this.data.variety_id) {
      this.varietyDetailObs = this.variedadService.getVarietyDetail(this.data.variety_id);
    }
  }
}
